import { TextureLoader } from 'three';

const getBg = (url) => {
  return new Promise(resolve => {
    new TextureLoader().load(url, resolve);
  });
}


const defaultBackground = (path) => {


  if (!url) {
    url = 'virtualRealityFiles/dreamstime.jpg';
  }

  const loader = new TextureLoader();

  // load a resource
  loader.load(
    // resource URL
    url,

    // onLoad callback
    function (texture) {
      console.log(texture);
      // in this example we create the material when the texture is loaded
      const material = new MeshBasicMaterial({
        map: texture
      });
    },

    // onProgress callback currently not supported
    undefined,

    // onError callback
    function (err) {
      console.log('An error happened.');
      console.log(err);
    }
  );

}

export const get_ = {
  getBg,
  defaultBackground,
}